export default "__VITE_ASSET__BxPI83jB__"